import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
} from "@/components/ui/Dialog";
import { Skeleton } from "@/components/ui/Skeleton";
import { useParams } from "@tanstack/react-router";
import { useDxReportView } from "../../network/useDxReportView";
import { AOEQuestionnaires } from "./AOEQuestionnaires";
import { Findings } from "./Findings";
import { ReportInfo } from "./ReportInfo";
import { ReportNotes } from "./ReportNotes";

export const DxReportViewer = ({
  diagnosticReportId,
  requestGroupId,
  onClose,
}: {
  diagnosticReportId: string;
  requestGroupId: string;
  onClose: () => void;
}) => {
  const { patientId } = useParams({ from: "/patient/$patientId" });
  const { data: dxReportView, isLoading: isDxReportViewLoading } =
    useDxReportView({
      patientId: patientId,
      diagnosticReportId: diagnosticReportId,
    });

  return (
    <Dialog open={true} onOpenChange={(open) => !open && onClose()}>
      <DialogPortal>
        <DialogOverlay />
        <DialogContent className="w-3/4 h-3/4 max-w-4xl flex flex-col">
          <DialogHeader>
            <DialogTitle>Lab Results Report</DialogTitle>
            <DialogDescription className="hidden">
              Lab Results Report
            </DialogDescription>
          </DialogHeader>
          <div className="flex flex-col flex-1 gap-3 overflow-y-auto h-full">
            {isDxReportViewLoading ? (
              <Skeleton className="h-[100px] w-full" />
            ) : (
              <Findings tests={dxReportView?.tests || []} />
            )}

            <AOEQuestionnaires
              patientId={patientId}
              requestGroupId={requestGroupId}
            />
            {isDxReportViewLoading || !dxReportView ? (
              <Skeleton className="h-[100px] w-full" />
            ) : (
              <ReportNotes dxReportView={dxReportView} />
            )}
            {isDxReportViewLoading || !dxReportView ? (
              <Skeleton className="h-[100px] w-full" />
            ) : (
              <ReportInfo dxReportView={dxReportView} />
            )}
          </div>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
};
